import { Component, OnDestroy, OnInit } from '@angular/core';
import { redirectToAccount } from '@app/shared/helpers/location';
import { Team } from '@app/shared/models/team';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import * as fromRoot from '../../reducers/index';
import { SEOService } from '@app/core/services/seo.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-files-expired',
  templateUrl: './files-expired.component.html',
  styleUrls: ['./files-expired.component.scss']
})
export class FilesExpiredComponent implements OnInit, OnDestroy {
  hasToken$: Observable<boolean>;
  selectedTeam$: Observable<Team>;
  subscriptions: Subscription[] = [];
  isLoggedIn: boolean;
  selectedTeam: Team;
  hostname = environment.appDomainWithProtocol;

  constructor(
    private readonly store$: Store<fromRoot.State>,
    private seoService: SEOService
  ) {
    this.hasToken$ = this.store$.select(fromRoot.getHasToken);
    this.selectedTeam$ = this.store$.select(fromRoot.getActiveTeam);
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.selectedTeam$.subscribe(selectedTeam => {
        this.selectedTeam = selectedTeam;
      }),
      this.hasToken$.subscribe(token => {
        this.isLoggedIn = !!token;
      }),
    );

    // Seo
    this.seoService.removeHreflang();
  }

  redirectToAccount() {
    redirectToAccount(this.selectedTeam.id)
  }

  ngOnDestroy(): void {
    this.subscriptions.map(subscription => subscription.unsubscribe());
  }

}
